/**
 * Apcam.Api.Web
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Model used to pass to the client SendGrid template update information.
 */
export interface UpdateSendGridTemplateModel { 
    /**
     * A unique string identifying a single template on SendGrid.
     */
    templateId: string;
    /**
     * Two letter language code associated with a specific SendGrid template.
     */
    language: string;
    /**
     * Localized subject for emails sent via the template.
     */
    subject: string;
}

